import React from "react";

const tiers = [
  {
    title: "Foundational Guidance",
    tag: "Free & Instant",
    color: "emerald",
    desc: "Quick answers to everyday business questions — registrations, taxes, structure, basics of hiring and compliance.",
    points: [
      "WhatsApp-first instant access",
      "Curated knowledge base",
      "Light-touch advisory & redirection",
      "Community Q&A and templates",
    ],
    icon: "fa-circle-info",
  },
  {
    title: "Expert Consulting",
    tag: "Pro Engagements",
    color: "orange",
    desc: "Deep, paid engagements with vetted specialists — funding, GTM, legal, hiring, finance, exits and more.",
    points: [
      "1:1 expert sessions.",
      "Documented diagnostics & action plans",
      "Funding readiness and investor intros",
      "Ongoing retainers for scale-ups",
    ],
    icon: "fa-chess-knight",
  },
];

const Services = () => {
  return (
    <section
      id="services"
      className="py-20 sm:py-28 bg-white"
      data-testid="services-section"
    >
      <div className="section">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="chip">
              <i className="fa-solid fa-layer-group text-blue-600"></i>
              Two-Level Support System
            </span>
            <h2 className="mt-4 font-display text-3xl sm:text-5xl font-bold text-slate-900 leading-tight">
              Right help, <span className="gradient-text">at the right depth.</span>
            </h2>
          </div>
          <p className="text-slate-600 max-w-md">
            Every business is at a different stage. IBH meets you where you are
            — with quick answers when you need them, and deep expertise when
            you're ready to scale.
          </p>
        </div>

        <div className="mt-14 grid lg:grid-cols-2 gap-6">
          {tiers.map((t, idx) => {
            const isOrange = t.color === "orange";
            return (
              <div
                key={t.level}
                className={`relative rounded-3xl p-8 border overflow-hidden card-hover ${
                  isOrange
                    ? "bg-gradient-to-br from-orange-50 via-white to-amber-50 border-orange-100"
                    : "bg-gradient-to-br from-emerald-50 via-white to-teal-50 border-emerald-100"
                }`}
                data-testid={`service-card-${t.level}`}
              >
                <div
                  className={`absolute -top-20 -right-20 h-64 w-64 rounded-full blur-3xl opacity-50 ${
                    isOrange ? "bg-orange-200" : "bg-emerald-200"
                  }`}
                ></div>

                <div className="relative">
                  <div className="flex items-center justify-between">
                    <span
                      className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-bold tracking-wider uppercase ${
                        isOrange
                          ? "bg-orange-500 text-white"
                          : "bg-emerald-600 text-white"
                      }`}
                    >
                      {t.tag}
                    </span>
                    <div
                      className={`h-12 w-12 rounded-2xl flex items-center justify-center text-white ${
                        isOrange ? "bg-ibh-orange" : "bg-ibh-green"
                      }`}
                    >
                      <i className={`fa-solid ${t.icon}`}></i>
                    </div>
                  </div>

                  <h3 className="mt-6 font-display text-2xl sm:text-3xl font-bold text-slate-900">
                    {t.title}
                  </h3>
                  <p className="mt-3 text-slate-600">{t.desc}</p>

                  <ul className="mt-6 space-y-2.5">
                    {t.points.map((p) => (
                      <li
                        key={p}
                        className="flex items-start gap-3 text-sm text-slate-700"
                      >
                        <i
                          className={`fa-solid fa-circle-check mt-0.5 ${
                            isOrange ? "text-orange-500" : "text-emerald-600"
                          }`}
                        ></i>
                        {p}
                      </li>
                    ))}
                  </ul>

   <a href={isOrange ? "https://wa.me/918274964884?text=Hi!%0AI%20would%20like%20to%20scale%20up%20my%20business%20with%20IBH%20%F0%9F%9A%80" : "https://wa.me/918274964884?text=Hi!%0AI%20would%20like%20to%20explore%20IBH%20in%20connection%20with%20my%20business%F0%9F%92%A1"}
  target="_blank"
  rel="noopener noreferrer"
  className={`mt-7 inline-flex items-center gap-2 
      font-semibold text-sm ${
  isOrange ? "text-orange-700" : "text-emerald-700"
  }`}
>
  {isOrange ? "Engage an expert" : "Get started free"}
  <i className="fa-solid fa-arrow-right text-xs"></i>
</a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
